import { useCallback, useContext } from 'react'
import type { ReactNode } from 'react'
import pointer from '../../utils/json-pointer'
import type { ComponentProps } from '../../types'
import type { ContextState } from '../Context'
import Context from '../Context'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type DataContextAtProps = ComponentProps & {
  /** JSON Pointer for where in the source dataset to point at in sub components */
  path?: string
  iterate?: boolean
  children?: ReactNode
}

function At(props: DataContextAtProps) {
  const { path = '/', iterate, children } = props
  const dataContext = useContext(Context)
  const {
    data: contextData,
    handlePathChange: handlePathChangeDataContext,
  } = dataContext

  const data =
    contextData && pointer.has(contextData, path)
      ? pointer.get(contextData, path)
      : undefined

  const handlePathChange: ContextState['handlePathChange'] = useCallback(
    (changePath, value) => {
      handlePathChangeDataContext(`${path}${changePath}`, value)
    },
    [handlePathChangeDataContext, path]
  )

  if (iterate) {
    if (!Array.isArray(data)) {
      return null
    }
    return (
      <>
        {data.map((element, i) => {
          const handlePathChange = (
            handlePathChangeDataContext
              ? (changePath, value) => {
                  handlePathChangeDataContext(
                    `${path}/${i}${changePath}`,
                    value
                  )
                }
              : undefined
          ) as ContextState['handlePathChange']

          return (
            <Context
              key={`element${i}`}
              value={{
                ...dataContext,
                data: element,
                handlePathChange,
              }}
            >
              {children}
            </Context>
          )
        })}
      </>
    )
  }

  return (
    <Context
      value={{
        ...dataContext,
        data,
        handlePathChange,
      }}
    >
      {children}
    </Context>
  )
}

withComponentMarkers(At, { _supportsSpacingProps: true })

export default At
